/**
 * Google Analytics events. gtag is only loaded on the production host (see
 * public/index.html), so on localhost, previews and in tests this is a no-op.
 * Never send personal data (name, e-mail) in event parameters.
 *
 * @param {string} name
 * @param {Record<string, string | number | boolean>} [params]
 */
export function track(name, params = {}) {
  if (typeof window !== "undefined" && typeof window.gtag === "function") {
    window.gtag("event", name, params);
  }
}
